import mycarsSrpVdp from './utils/mycarsSrpVdp';

export default {
	events: {
		widgetUserEvent: [...mycarsSrpVdp.widgetUserEvent]
	}
};
